
module.exports = { 
      attributes: {},
    
      body: "Aged care is the support provided to older people in their own home or in an aged care (nursing) home. It can include help with everyday living, health care, accommodation, and equipment such as walking frames or ramps.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/ageing.md"},
     }